import { Platform } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    base: [
      'relative cursor-pointer justify-center rounded-md text-center font-F37Bold text-sm font-bold lowercase leading-none outline-0',
      Platform.OS === 'web' &&
        'transition-all duration-150 ease-out active:transition-none',
    ],
    variants: {
      variant: {
        primary:
          'bg-accentPrimary40 shadow-resting-accentPrimary40 hover:shadow-hovering-accentPrimary40 active:shadow-none',
        secondary:
          'bg-accentPrimary20 shadow-resting-accentPrimary20 hover:shadow-hovering-accentPrimary20 active:shadow-none',
        tertiary: 'group',
        info: 'bg-neutral10 shadow-resting-neutral10 hover:shadow-hovering-neutral10 active:shadow-none',
      },
      size: {
        sm: 'min-h-[3.2rem] min-w-[11rem] px-md py-sm',
        md: 'min-h-[4.8rem] min-w-[14rem] px-xl py-md',
      },
      disabled: {
        true: 'cursor-default',
      },
      empty: { true: '' },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
      disabled: false,
    },
    compoundVariants: [
      {
        variant: ['primary', 'secondary', 'info'],
        disabled: true,
        className:
          'bg-neutral30 shadow-none hover:shadow-none active:shadow-none',
      },
      {
        size: 'sm',
        empty: true,
        className: 'w-[3.2rem] min-w-0 px-sm py-sm',
      },
      {
        size: 'md',
        empty: true,
        className: 'w-[4.8rem] min-w-0 px-md py-md',
      },
      {
        variant: 'tertiary',
        size: ['sm', 'md'],
        className: 'min-w-0 px-0',
      },
    ],
  }),
  label: tv({
    base: 'font-F37Bold text-sm lowercase leading-none',
    variants: {
      variant: {
        primary: 'text-neutral30',
        secondary: 'text-neutral30',
        tertiary:
          'text-accentPrimary10 group-hover:color-accentPrimary20 group-active:color-accentPrimary20',
        info: 'text-neutral30',
      },
      disabled: {
        true: 'text-neutral20 group-hover:text-neutral20 group-active:text-neutral20',
      },
    },
    defaultVariants: {
      variant: 'primary',
      disabled: false,
    },
  }),
  loadingIcon:
    'absolute shrink-0 w-[1.4rem] h-[1.4rem] -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2',
  loadingContent: 'opacity-0',
};
